export default __webpack_public_path__ + "static/notosans-regular-webfont-334c209b5de521256e50e21543025399.woff";